// Gated solely on a per-browser debug kill switch: default OFF ⇒ feature on, set
// ON to disable locally. Uses a NEW key (`epoLeadsCaptureBuyerDisabled`) rather
// than inverting the retired `epoLeadsCaptureBuyer`, because debug settings persist
// in localStorage (`max-debug-storage`): a browser that had toggled the old key ON
// would carry a stale `true` that inverting the same key would misread as
// "disabled". A store missing the new key reads `undefined` (falsy ⇒ on), so the
// launch reaches every user regardless of cache — and the runtime dual-gate on an
// AIPOS `leadCampaignId` still limits it to allowlisted products.
export const isLeadsCaptureEnabledBuyer = (debugDisableToggle: boolean): boolean => !debugDisableToggle;
